<template>
  <r-dialog ref="dialog" :title="hasSSO ? $t('select_account_to_access') : $t('select_region')" @close="onDismiss()" :maxWidth="400" :persistent="persistent" :primaryActionLabel="''" :secondaryActionLabel="''">
    <v-list two-line slot="full-width-content" data-testid="login-option-list">
      <template v-for="(login_option, index) in loginOptions">
        <v-list-item :key="index" @click="useOption(login_option)">
          <v-list-item-content>
            <v-list-item-title>
              {{login_option.name}}
              <span v-if="login_option['@type'] == 'Password'">{{ $t('region') }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </r-dialog>
</template>

<script>

export default {
  name: 'LoginOptionsListDialog',
  components: {
  },
  props: {
    persistent: {
      type: Boolean,
      default: false
    },
    loginOptions: Array
  },
  data () {
    return {
    }
  },
  methods: {
    useOption(login_option) {
      this.$emit('useOption', login_option);
    },
    onDismiss() {
      this.$emit('dismissed');
    }
  },
  computed: {
    hasSSO() {
      if (this.loginOptions == null) return false;
      return this.loginOptions.find(opt => opt['@type'] == "SSO") != null;
    }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  watch: {
    loginOptions(login_options) {
      if (login_options != null && login_options.length > 0) {
        this.$refs.dialog.show(null, false, true);
      }
      else {
        this.$refs.dialog.hide();
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/login/LoginOptionListDialog.vue